import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentFacilityCarePath} from './PropertyPaths/accidentFacilityCarePath';

export const RehabilitationFacility = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedProduct} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentFacilityCarePath(selectedPlan?.planIndex ?? 0, 0);

  const productCd = selectedProduct?.code ?? '';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'rehabilitation-facility-row-1'},
      items: [
        {
          key: propertyPaths.rehabilitationFacilityDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.rehabilitationFacilityDetails.incurralPeriod)}
              disabled
              id={propertyPaths.rehabilitationFacilityDetails.incurralPeriod}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.rehabilitationFacilityDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.rehabilitationFacilityDetails.customizeBenefitAmount)}
              disabled
              id={propertyPaths.rehabilitationFacilityDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'rehabilitation-facility-row-2'},
      items: [
        {
          key: propertyPaths.rehabilitationFacilityDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount (Per Day)"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.rehabilitationFacilityDetails.benefitAmount)
              )}
              disabled
              id={propertyPaths.rehabilitationFacilityDetails.benefitAmount}
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'rehabilitation-facility-row-3'},
      items: [
        {
          key: propertyPaths.rehabilitationFacilityDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Number of Days per Time Period #1"
              value={getQuoteFieldValue<number>(propertyPaths.rehabilitationFacilityDetails.maxBenefitNumber)}
              id={propertyPaths.rehabilitationFacilityDetails.maxBenefitNumber}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.rehabilitationFacilityDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Time Period #1"
              searchKey={`${productCd}RehabilitationFacilityBenefit.timePeriodCd`}
              value={getQuoteFieldValue<number>(propertyPaths.rehabilitationFacilityDetails.timePeriodCd)}
              disabled
              id={propertyPaths.rehabilitationFacilityDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'rehabilitation-facility-row-4'},
      items: [
        {
          key: propertyPaths.rehabilitationFacilityDetails.maxBenefitNumber2,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Number of Days per Calendar Year per Time Period #2"
              value={getQuoteFieldValue<number>(propertyPaths.rehabilitationFacilityDetails.maxBenefitNumber2)}
              disabled
              id={propertyPaths.rehabilitationFacilityDetails.maxBenefitNumber2}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.rehabilitationFacilityDetails.timePeriod2Cd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Time Period #2"
              searchKey={`${productCd}RehabilitationFacilityBenefit.timePeriod2Cd`}
              value={getQuoteFieldValue<number>(propertyPaths.rehabilitationFacilityDetails.timePeriod2Cd)}
              disabled
              id={propertyPaths.rehabilitationFacilityDetails.timePeriod2Cd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};
